/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-11 15:29:38
 * @LastEditTime: 2022-01-11 16:47:33
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联对账单->汇总数据订单明细数据->汇总数据订单明细数据详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataOrderDetailModal.jsx
 */

import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchPlatformRecordYlPayOrderSummaryDataOrderInfoGet } from '../../../../services/platformAccountingRecord';
import { formatTime } from '../../../../utils';

const YlPayOrderSummaryDataOrderDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postGet(id)
    }
    const close = () => {
        setVisible(false)
    }
    const postGet = (id) => {
        setLoading(true)
        fetchPlatformRecordYlPayOrderSummaryDataOrderInfoGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false)
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="对账详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
               
                    <CustomRow divider>
                        <CustomCol label="实际支付金额">
                            <span style={{ paddingLeft:6 }}>{detailData.actualPaymentAmount}</span>
                        </CustomCol>
                        <CustomCol label="分店简称">
                            <span style={{ paddingLeft:6 }}>{detailData.branchStore}</span>
                        </CustomCol>
                        <CustomCol label="卡类型">
                            <span style={{ paddingLeft:6 }}>{detailData.cardType}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="支付类型">
                            <span style={{ paddingLeft:6 }}>{detailData.payType}</span>
                        </CustomCol>
                        <CustomCol label="付款附言">
                            <span style={{ paddingLeft:6 }}>{detailData.postscriptPayment}</span>
                        </CustomCol>
                    
                        <CustomCol label="参考号">
                            <span style={{ paddingLeft:6 }}>{detailData.referenceNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                       
                        <CustomCol label="退货订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.returnGoodsOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="流水号">
                            <span style={{ paddingLeft:6 }}>{detailData.serialNumber}</span>
                        </CustomCol>
                    </CustomRow>
                
                    <CustomRow divider>
                        <CustomCol label="商户订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.merchantOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="商户号">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantNumber}</span>
                        </CustomCol>
                    </CustomRow>
                 
                    <CustomRow divider>
                        <CustomCol label="子订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.childOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="创建时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.createTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider >
                        <CustomCol label="银商订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.silverMerchantOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.serviceCharge}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="备注信息" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.remark}</span>
                        </CustomCol>
                        <CustomCol label="其他优惠金额">
                            <span style={{ paddingLeft:6 }}>{detailData.otherDiscountAmount}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="清算金额">
                            <span style={{ paddingLeft:6 }}>{detailData.liquidationAmount}</span>
                        </CustomCol>
                        <CustomCol label="商户优惠金额">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantDiscountAmount}</span>
                        </CustomCol>
                        <CustomCol label="商户名称">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantName}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider >
                        <CustomCol label="分期期数">
                            <span style={{ paddingLeft:6 }}>{detailData.stagesNumber}</span>
                        </CustomCol>
                        <CustomCol label="分期手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.stagesServiceCharge}</span>
                        </CustomCol>
                        <CustomCol label="分期服务方">
                            <span style={{ paddingLeft:6 }}>{detailData.stagesServiceParty}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider >
                        <CustomCol label="第三方订单号" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{detailData.thirdPartyOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="终端号">
                            <span style={{ paddingLeft:6 }}>{detailData.terminalNumber}</span>
                        </CustomCol>
                     
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="发卡行">
                            <span style={{ paddingLeft:6 }}>{detailData.issuingBank}</span>
                        </CustomCol>
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeAmount}</span>
                        </CustomCol>
                        <CustomCol label="分期付息方">
                            <span style={{ paddingLeft:6 }}>{detailData.stagesInterestPayer}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider >
                        <CustomCol label="交易卡号">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeCardNumber}</span>
                        </CustomCol>
                    
                        <CustomCol label="交易日期">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeDate}</span>
                        </CustomCol>
                        <CustomCol label="交易日期时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.tradeDateTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易时间">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeTime}</span>
                        </CustomCol>
                        <CustomCol label="交易类型">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeType}</span>
                        </CustomCol>
                        <CustomCol label="钱包优惠金额">
                            <span style={{ paddingLeft:6 }}>{detailData.walletDiscountAmount}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default YlPayOrderSummaryDataOrderDetail


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataOrderDetailModal.jsx